import { css } from '@emotion/react';
import { Color } from "../../constants/Colors";

export const useStyles = (props) => ({
  drawerMenu: css({
    position: "relative",
    marginBottom: 32,
  }),
  drawerMenuLabel: css({
    cursor: "pointer",
  }),
  drawerSubmenuContainer: css({
    position: "relative",
    width: "100%",
    marginTop: 16,
  }),
  drawerThirdSubmenuContainer: css({
    position: "relative",
    width: "100%",
    marginTop: 16,
  }),
  drawerSubmenu: css({
    boxSizing: "border-box",
    paddingTop: 14,
    paddingBottom: 14,
    backgroundColor: Color.neutral[0],
    cursor: "pointer",
    "&:hover": {
      background: Color.neutral[100],
    },
  }),
  drawerThirdSubmenu: css({
    boxSizing: "border-box",
    paddingTop: 14,
    paddingBottom: 14,
    backgroundColor: Color.neutral[0],
    cursor: "pointer",
    "&:hover": {
      background: Color.neutral[100],
    },
  }),
  drawerSubmenuLabel: css({
    position: "relative",
  }),
  drawerSubmenuVerticalBar: css({
    position: "absolute",
    top: 18,
    left: 40,
    bottom: 18,
    marginRight: 16,
    borderLeft: `2px solid ${Color.neutral[200]}`,
    zIndex: 100000,
  }),
  drawerSubmenuVerticalPosition: css({
    height: 16,
    position: "absolute",
    left: 40,
    marginRight: 16,
    transition: `all 0.2s linear`,
    borderLeft: `2px solid ${Color.neutral[700]}`,
    zIndex: 100001,
  }),
  drawerThirdSubmenuVerticalBar: css({
    position: "absolute",
    top: 18,
    left: 60,
    bottom: 18,
    marginRight: 16,
    borderLeft: `2px solid ${Color.neutral[200]}`,
    zIndex: 100000,
  }),
  drawerThirdSubmenuVerticalPosition: css({
    height: 16,
    position: "absolute",
    left: 60,
    marginRight: 16,
    transition: `all 0.2s linear`,
    borderLeft: `2px solid ${Color.neutral[700]}`,
    zIndex: 100001,
  }),
  drawerMenuIsCustomizedTag: css({
    position: "absolute",
    top: 0,
    left: 0,
    width: 8,
    height: 8,
    background: Color.alert[700],
    borderRadius: "50%",
  }),
  drawerSubmenuIsCustomizedTag: css({
    position: "absolute",
    top: 0,
    left: 50,
    width: 8,
    height: 8,
    background: Color.alert[700],
    borderRadius: "50%",
  }),
  drawerThirdSubmenuIsCustomizedTag: css({
    position: "absolute",
    top: 0,
    left: 70,
    width: 8,
    height: 8,
    background: Color.alert[700],
    borderRadius: "50%",
  }),
});
